<template>
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col cols="auto" class="headline">Operator</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="mb-2" :loading="operatorLoading">
          <v-card-title class="flex-column align-start">
            <div>{{operator.name}}</div>
            <span class="subtitle-1">{{operator.description}}</span>
            <div class="mt-4">
              <function-icon v-if="operator.table_ordering" text="Has table ordering" icon="mdi-table-chair" />
              <function-icon v-if="operator.table_ordering && operator.table_bills" text="Has table bills" icon="mdi-receipt" />
              <function-icon v-if="operator.barview_messages" text="Has barview messages" icon="mdi-message-text"/>
              <function-icon v-if="operator.wait_for_orders" text="Has wait for orders" icon="mdi-clock" />
              <function-icon v-if="operator.product_categories" text="Has product categories" icon="mdi-shape" />
              <function-icon v-if="operator.layout_items == 'list'" text="List layout" icon="mdi-format-list-bulleted" />
              <function-icon v-if="operator.cardreader_brand  == 'bambora'" text="Has cardreader bambora" icon="mdi-alpha-b-circle" />
              <function-icon v-if="operator.cardreader_brand == 'izettle'" text="Has cardreader izettle" icon="mdi-alpha-z-circle" />
            </div>
          </v-card-title>
          <v-card-text v-if="operator.hidden || operator.unlisted">
            <span v-if="operator.hidden">
              <v-icon left>mdi-eye-off</v-icon><span>Hidden</span>
            </span>
            <span v-if="operator.unlisted">
              <span v-if="operator.hidden"><br /></span>
              <v-icon left>mdi-sort-variant-remove</v-icon><span>Unlisted</span>
            </span>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click.stop="openOperatorForm">Edit</v-btn>
            <v-btn color="primary" text :loading="isRemovingOperator" @click="deleteOperator">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-switch
              v-model="productDraggable"
              label="Drag to sort"
              color="primary"
              />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <products class="my-8" :operator="operator" :disableDraggable="productDraggable"/>

    <v-dialog :value="editingOperator" @input="closeOperatorForm()" max-width="600px" persistent scrollable>
      <operator-form ref="operatorForm" :operator="operator" @submit="saveOperator" @cancel="closeOperatorForm"/>
    </v-dialog>

  </v-container>
</template>

<script>
import OperatorForm from '../components/OperatorForm.vue'
import Products from '../components/Products.vue'
import {getItemById} from '@dynapp/wc-api-generic';
import itemsLayouts from '../components/itemsLayouts';
import FunctionIcon from '../components/FunctionIcon.vue';

export default {
  props: ['id'],
  data () {
    return {
      editingOperator: false,
      isRemovingOperator: false,
      productDraggable: false
    }
  },
  computed: {
    itemsLayout() {
      var layout = getItemById(itemsLayouts, this.operator.layout_items, 'value');
      if (layout == null) {
        layout = getItemById(itemsLayouts, '2-grid', 'value');
      }
      return layout || {};
    },
    operator () {
      return this.$store.getters['operators/getItemById'](this.id) || {};
    },
    operatorLoading () {
      return this.$store.getters.isLoadingFor('operators.read');
    }
  },
  methods: {
    openOperatorForm () {
      this.editingOperator = true;
    },
    closeOperatorForm () {
      this.editingOperator = false;
      this.$refs.operatorForm.reset();
    },
    saveOperator (operator) {
      this.$store.dispatch('operators/updateItem', operator).then(() => {
        this.closeOperatorForm();
        this.$snackbar({message: 'Operator saved', theme: 'success'});
      }, () => {
        this.$snackbar({message: 'Could not save operator', theme: 'error'});
      });
    },
    deleteOperator () {
      this.$confirm({
        title: `Are you sure you want to delete operator "${this.operator.name}"?`,
        message: 'You cannot undo this action'
      }).then(() => {
        this.removingOperator = true;
        this.$store.dispatch('operators/deleteItem', this.id).then(() => {
          this.removingOperator = false;
          this.$snackbar({message: 'Operator deleted', theme: 'success'});
          this.$router.replace('/');
        });
      });
    }
  },
  components: {
    OperatorForm,
    Products,
    FunctionIcon
  }
}
</script>

<style lang="scss">
</style>
